import type {RowData} from '../../types/RowData';
import {selectRows} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useGridRows(): RowData[] {
  return useEagGridSelector(selectRows);
}
